import React, { useRef, useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../../../contexts/AuthContext';
import styles from './Dashboard.module.scss';

export default function ChangePasswordForm({ onSaved }) {
    const currentPasswordRef = useRef();
    const newPasswordRef = useRef();
    const confirmPasswordRef = useRef();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const { updatePassword } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (newPasswordRef.current.value !== confirmPasswordRef.current.value) {
            return setError('Passwords do not match');
        }

        setLoading(true);

        try {
            const result = await updatePassword(currentPasswordRef.current.value, newPasswordRef.current.value);
            if (!result.success) {
                setError(result.error);
            } else {
                setSuccess('Password updated');
                e.target.reset();
                // Give the confirmation a moment to register before folding the row closed.
                setTimeout(() => onSaved?.(), 1200);
            }
        } catch (err) {
            setError('Failed to update password');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {error && <div className={styles.error}>{error}</div>}
            {success && <div className={styles.success}>{success}</div>}
            <form onSubmit={handleSubmit}>
                <label>Current password</label>
                <div className={styles.passwordField}>
                    <input ref={currentPasswordRef} type={showCurrent ? 'text' : 'password'} required autoFocus/>
                    <button type="button" className={styles.passwordToggle} onClick={() => setShowCurrent(!showCurrent)} aria-label={showCurrent ? 'Hide password' : 'Show password'}>
                        <FontAwesomeIcon icon={showCurrent ? faEye : faEyeSlash}/>
                    </button>
                </div>
                <label>New password</label>
                <div className={styles.passwordField}>
                    <input ref={newPasswordRef} type={showNew ? 'text' : 'password'} required minLength={6}/>
                    <button type="button" className={styles.passwordToggle} onClick={() => setShowNew(!showNew)} aria-label={showNew ? 'Hide password' : 'Show password'}>
                        <FontAwesomeIcon icon={showNew ? faEye : faEyeSlash}/>
                    </button>
                </div>
                <label>Confirm new password</label>
                <input ref={confirmPasswordRef} type={showNew ? 'text' : 'password'} required minLength={6}/>
                <button type="submit" className={styles.button} disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </form>
        </>
    )
}
